import React from "react";
import ReactDotdotdot from "react-dotdotdot";
import Box, { BoxProps } from "../box/Box";

interface ITextProps {
  clamp?: number;
}

const Text: React.FC<BoxProps & ITextProps> = React.forwardRef<any, BoxProps & ITextProps>(
  ({ clamp, display, ...props }, ref) => {
    if (clamp) {
      const isInlineDisplay = ["inline", "inline-block", "inline-flex", "inline-grid"].includes(display as string);

      return (
        <Box
          ref={ref}
          as="p"
          fontFamily="body"
          mb={0}
          display={display}
          {...props}
          css={{
            "> span": {
              display: isInlineDisplay ? (display as string) : "block",
            },
          }}
        >
          <ReactDotdotdot clamp={clamp} useNativeClamp={true} tagName="span">
            {props.children}
          </ReactDotdotdot>
        </Box>
      );
    }

    return <Box ref={ref} as="p" fontFamily="body" mb={0} display={display} {...props} />;
  },
);

Text.displayName = "Text";

export default Text;
